var _rect, _rect2, _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSdWanRouter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 40,
    width: 1.5,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.10742,51.78125a4.731,4.731,0,0,0-8.26465-1.76855L53.19141,46.75H56a.7502.7502,0,0,0,.75-.75V34a.7502.7502,0,0,0-.75-.75H53.19629L58.834,29.99091a4.78477,4.78477,0,1,0-.74023-1.30451L50.19922,33.25H40.75V18.67419A4.74124,4.74124,0,0,0,40.01172,9.25H40.001a4.74089,4.74089,0,0,0-.751,9.42352V33.25h-2.5V24h-1.5v9.25H32.751L32.75,28h-1.5l.001,5.25h-1.4502l-7.8916-4.56183a4.72,4.72,0,0,0-2.041-5.79608,4.75313,4.75313,0,1,0-1.166,8.69873,4.70076,4.70076,0,0,0,2.45605-1.60443L26.80371,33.25H24a.7502.7502,0,0,0-.75.75V46a.7502.7502,0,0,0,.75.75h2.61133l-5.46,3.25537a4.75767,4.75767,0,1,0,.75049,1.2984L29.53906,46.75H39.25V61.32581A4.74124,4.74124,0,0,0,39.98828,70.75H39.999a4.74089,4.74089,0,0,0,.751-9.42352V46.75h9.44189l7.89942,4.56085A4.73634,4.73634,0,0,0,62.50879,57.749a4.74882,4.74882,0,0,0,4.59863-5.96777Zm-6.21-27.59961a3.23785,3.23785,0,0,1,1.61426-.4331,3.27682,3.27682,0,0,1,.85351.11425,3.24979,3.24979,0,1,1-2.46777.31885ZM20.294,28.63135A3.24837,3.24837,0,1,1,20.625,26.166,3.227,3.227,0,0,1,20.294,28.63135Zm-1.19141,27.187a3.24947,3.24947,0,1,1,1.19922-4.437A3.23149,3.23149,0,0,1,19.10254,55.81836ZM36.75,13.99268A3.25,3.25,0,0,1,40.001,10.75h.00683a3.25,3.25,0,0,1-.00879,6.5h-.00683A3.254,3.254,0,0,1,36.75,13.99268Zm6.5,52.01464A3.25,3.25,0,0,1,39.999,69.25h-.00683a3.25,3.25,0,0,1,.00879-6.5h.00683A3.254,3.254,0,0,1,43.25,66.00732ZM24.75,45.25V34.75h30.5v10.5Zm40.57812,9.38135A3.24981,3.24981,0,1,1,65.6582,52.166,3.255,3.255,0,0,1,65.32812,54.63135Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 40,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 40,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSdWanRouter);
export default __webpack_public_path__ + "static/media/icon_sd_wan_router.f540e007ee78cd970efb0217a56cabf5.svg";
export { ForwardRef as ReactComponent };